import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const MyProgramPage = lazy(() => import("./MyProgramPage").then((module) => ({ default: module.MyProgramPage })));

export function MyProgramPageAsync() {
  return (
    <Suspense fallback={<LoadingIndicatorFullPage open />}>
      <MyProgramPage />
    </Suspense>
  );
}
